import axios from 'axios';
import React, { createContext, useState, useEffect, useContext } from 'react';
import secureLocalStorage from 'react-secure-storage';

const SettingsContext = createContext();
export const SettingsProvider = ({ children }) => {

    const renderHTML = (escapedHTML) => React.createElement("div", { dangerouslySetInnerHTML: { __html: escapedHTML } });

    const [settings, setSettings] = useState("");
    const [user, setUser] = useState(null);

    useEffect(() => {
        const savedUser = secureLocalStorage.getItem('user');
        if (savedUser) {
            setUser(JSON.parse(savedUser))
        }
    }, []);

    const Logout = (e) => {
        e.preventDefault();
        secureLocalStorage.removeItem('user');
        setUser(null)
        window.location.replace('/');
    };

    const getSetting = async () => {
        try {
            const res = await axios.get(`${process.env.REACT_APP_API_URL}api/get-settings`);
            setSettings(res.data.data)
        } catch (err) {
            console.error('Error Settings Content:', err);
        }
    }

    useEffect(() => {
        getSetting();
    }, []);

    return (
        <SettingsContext.Provider value={{ renderHTML, settings, user, Logout }}>
            {children}
        </SettingsContext.Provider>
    );
};


export const useSettings = () => {
    return useContext(SettingsContext);
};